
import React, { useEffect, useState } from 'react'
import { Box, Grid, Paper, IconButton, Stack } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DeleteIcon from '@mui/icons-material/Delete';
import { useBaseQuery } from 'src/api/core/useBaseQuery';
import ByzMuiDataGrid from 'src/components/core-components/mui/data-grid';
import { useMutation } from '@tanstack/react-query';
import { baseService } from 'src/api/core/baseService';
import OpenComponentDialog from 'src/components/shared-components/modal/openComponentModal';
import LiquidInDetailModal from './LiquidInDetailModal';
import ByzDeleteConfirmDialog from 'src/components/core-components/mui/ByzDeleteConfirmDialog';
import { queryClient } from 'src';

function LiquidInTable({ comId, setFbid }: any) {


  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState<number | null>(null);
  const [selectedFbId, setSelectedFbId] = useState<number | null>(null);
  const [selectedStartingAmount, setSelectedStartingAmount] = useState<number>(0);
  const [selectedDeliverySpeed, setSelectedDeliverySpeed] = useState<number>(0);
  const [selectedAppliedAmount, setSelectedAppliedAmount] = useState<number>(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteDetailDialogOpen, setDeleteDetailDialogOpen] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState<number | null>(null);


  const { data: fluidTypes, isLoading, refetch } = useBaseQuery<any>({
    endpoint: `/reference/api/Card/GetFluidBalanceFluidIntakes?comId=${comId}`,
    queryKey: ['LiquidInTable', comId],
    options: {
      enabled: comId > 0,
    }
  });

  useEffect(() => {
    if(fluidTypes && fluidTypes.data.length > 0 && setFbid){
      console.log('Setting fbid in LiquidInTable:', fluidTypes.data[0].fbid);
      setFbid(fluidTypes.data[0].fbid);
    }
  }, [fluidTypes, setFbid]);

  const deleteMutation = useMutation({
    mutationFn: (id: number) => baseService.delete(`/reference/api/Card/DeleteFluidBalanceFluidIntake/`, id),
    onSuccess: () => {
      refetch();
      queryClient.invalidateQueries({ queryKey: ['fluidTypesBalance'] });
    },
    onError: (error) => {
      console.error('Silme hatası:', error);
      alert('Silme işlemi başarısız oldu.');
    },
  });


  const deleteDetailMutation = useMutation({
    mutationFn: (id: number) => baseService.delete(`/reference/api/Card/DeleteFluidBalanceFluidIntDet/`, id),
    onSuccess: () => {
      refetch();
      queryClient.invalidateQueries({ queryKey: ['fluidTypesBalance'] });
    },
    onError: (error) => {
      console.error('Detay silme hatası:', error);
      alert('Detay silme işlemi başarısız oldu.');
    },
  });

  const handleDelete = (row: any) => {
    setDeleteTargetId(row.id);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (deleteTargetId) {
      deleteMutation.mutate(deleteTargetId);
    }
  };

  const handleDetailDelete = (row: any) => {
    setDeleteTargetId(row.id);
    setDeleteDetailDialogOpen(true);
  };

  const handleConfirmDetailDelete = async () => {
    if (deleteTargetId) {
      deleteDetailMutation.mutate(deleteTargetId);
    }
  };

  const handleOpenDetailModal = (parentId: number, startingAmount: number, fbId: any, deliverySpeed: number, appliedAmount: number) => {
    setSelectedParentId(parentId);
    setSelectedStartingAmount(startingAmount);
    setDetailModalOpen(true);
    setSelectedFbId(fbId);
    setSelectedDeliverySpeed(deliverySpeed || 0);
    setSelectedAppliedAmount(appliedAmount || 0);
  };

  const handleCloseDetailModal = () => {
    setDetailModalOpen(false);
    setSelectedParentId(null);
    setSelectedStartingAmount(0);
    setSelectedDeliverySpeed(0);
    setSelectedAppliedAmount(0);
  };

  const columns: GridColDef[] = [
    {
      field: 'add',
      headerName: 'Ekle',
      width: 80,
      renderCell: (params) => (
        <IconButton size="small" onClick={() => handleOpenDetailModal(params.row.id, params.row.startingamount, params.row.fbid, params.row.deliveryspeedplan, params.row.appliedamount)}>
          <AddIcon fontSize="small" />
        </IconButton>
      ),
    },
    {
      field: 'ptime',
      headerName: 'İşlem Zamanı',
      width: 150,
      valueFormatter: (params) => {
        if (!params) return '';
        const date = new Date(params);
        return date.toLocaleString('tr-TR');
      },
    },
    {
      field: 'ftname',
      headerName: 'Tipi',
      width: 150,
    },
    {
      field: 'fname',
      headerName: 'Adı',
      width: 200,
    },
    {
      field: 'startingamount',
      headerName: 'Başlangıç M.',
      width: 120,
      valueFormatter: (params) => params ? `${params} ml` : '',
    },
    {
      field: 'appliedamount',
      headerName: 'Uygulananlar',
      width: 120,
      valueFormatter: (params) => params ? `${params} ml` : '',
    },
    {
      field: 'psname',
      headerName: 'Durumu',
      width: 120,
    },
    {
      field: 'cuser',
      headerName: 'İşlem Yapan',
      width: 120,
    },
    {
      field: 'actions',
      headerName: '',
      width: 100,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <IconButton size="small" onClick={() => handleDelete(params.row)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const detailColumns: GridColDef[] = [
    {
      field: 'amount',
      headerName: 'Miktar',
      width: 120,
      valueFormatter: (params) => params ? `${params} ml` : '',
    },
    {
      field: 'deliveryspeed',
      headerName: 'Verme Hızı',
      width: 120,
      valueFormatter: (params) => params ? `${params} ml/h` : '',
    },
    {
      field: 'ptime',
      headerName: 'İşlem Zamanı',
      width: 150,
      valueFormatter: (params) => {
        if (!params) return '';
        const date = new Date(params);
        return date.toLocaleString('tr-TR');
      },
    },
    {
      field: 'cuser',
      headerName: 'İşlem Yapan',
      width: 120,
    },
    {
      field: 'actions',
      headerName: '',
      width: 100,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <IconButton size="small" onClick={() => handleDetailDelete(params.row)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const getDetailPanelContent = React.useCallback(
    ({ row }: any) => {
      if (!row.details || row.details.length === 0) return null;

      return (
        <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
          <ByzMuiDataGrid
            columns={detailColumns}
            rows={row.details}
            whiteGrid={false}
            hideFooter
            autoHeight
            getRowId={(row) => row.id}
          />
        </Box>
      );
    },
    [detailColumns]
  );

  const getDetailPanelHeight = React.useCallback(
    ({ row }: any) => {
      if (!row.details || row.details.length === 0) return 0;
      return 'auto';
    },
    []
  );

  return (
    <Grid xs={12} md={6}>
      <Paper sx={{ p: 2, borderRadius: '16px' }}>
        <Box sx={{ mb: 2, fontWeight: 600 }}>Aldığı Sıvı</Box>
        {fluidTypes && !isLoading ? (
          <ByzMuiDataGrid
            columns={columns}
            rows={fluidTypes.data || []}
            whiteGrid={true}
            hideFooter
            autoHeight
            getRowId={(row) => row.id}
            getDetailPanelContent={getDetailPanelContent}
            getDetailPanelHeight={getDetailPanelHeight}
            slots={{
              detailPanelExpandIcon: KeyboardArrowDownIcon,
              detailPanelCollapseIcon: KeyboardArrowDownIcon,
            }}
          />
        ) : (
          <Box>Yükleniyor...</Box>
        )}
      </Paper>

      <OpenComponentDialog
        showPatientData={false}
        title="Sıvı Detayı Ekle"
        open={detailModalOpen}
        onClose={handleCloseDetailModal}
        maxWidth="sm"
      >
        {selectedParentId && (
          <LiquidInDetailModal
            parentId={selectedParentId}
            fbId={selectedFbId !== null ? selectedFbId : 0}
            startingAmount={selectedStartingAmount}
            remainingAmount={selectedStartingAmount - selectedAppliedAmount}
            deliverySpeed={selectedDeliverySpeed}
            onClose={handleCloseDetailModal}
            onSave={() => {
              refetch();
              queryClient.invalidateQueries({ queryKey: ['fluidTypesBalance'] });

            }}
          />
        )}
      </OpenComponentDialog>

      <ByzDeleteConfirmDialog
        open={deleteDialogOpen}
        onClose={() => {
          setDeleteDialogOpen(false);
          setDeleteTargetId(null);
        }}
        onConfirm={handleConfirmDelete}
        title="Sıvı Kaydını Sil"
        content="Bu sıvı kaydını silmek istediğinizden emin misiniz?"
        hideSnackbar
      />

      <ByzDeleteConfirmDialog
        open={deleteDetailDialogOpen}
        onClose={() => {
          setDeleteDetailDialogOpen(false);
          setDeleteTargetId(null);
        }}
        onConfirm={handleConfirmDetailDelete}
        title="Detay Kaydını Sil"
        content="Bu detay kaydını silmek istediğinizden emin misiniz?"
        hideSnackbar
      />
    </Grid>
  );
}

export default LiquidInTable